export enum TransCountType {
    /// <summary>
    /// Valore medio dell'operazione
    /// </summary>
    AverageValue = 0,

    /// <summary>
    /// Valore totale dell'operazione
    /// </summary>
    TotalValue = 1,

    /// <summary>
    /// Conteggio medio dei pezzi
    /// </summary>
    AveragePiecesCount = 2,

    /// <summary>
    /// Conteggio totale dei pezzi
    /// </summary>
    TotalPiecesCount = 3,

    /// <summary>
    /// Conteggio medio delle operazioni
    /// </summary>
    AverageOperationCount = 4,

    /// <summary>
    /// Conteggio delle operazioni
    /// </summary>
    TotalOperationCount = 5,

    DenominationDistribution = 6,
}
